import { faMapMarkerPlus } from '@fortawesome/pro-solid-svg-icons';
import { type FC } from 'react';
import { useDispatch } from 'react-redux';
import { ALL_MAP_RELATED_PAGES } from '~/_shared/components/modal/modal.constants';
import { useTranslation } from '~/_shared/utils/hooks';
import { ModalType } from '~/modal/modalType.enum';
import { useModal } from '~/modal/useModal.hook';
import {
  startSelectLocationTool, stopSelectLocationTool,
} from '~/store/frontendState/mapTools/selectLocation/selectLocation.actionCreators';
import {
  useIsSelectLocationActive, useSelectLocationIsLoadingSelector,
} from '~/store/frontendState/mapTools/selectLocation/selectLocation.selectors';
import { SelectLocationConfiguration } from '~/store/frontendState/mapTools/selectLocation/selectLocation.state';
import { RightSideMapToolsMenuItem } from './rightSideMapToolsMenuItem.component';

export const RightSideAddMarkerMenuItem: FC = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const { openModal: optionsModal } = useModal(ModalType.OptionsModal);
  const { openModal: addMultipleLocationsModal } = useModal(ModalType.AddMultipleLocations);
  const isLoadingSelectLocation = useSelectLocationIsLoadingSelector();
  const isSelectLocationToAddLocationActive = useIsSelectLocationActive(SelectLocationConfiguration.AddLocation);

  const onPlaceMarkerOnTheMap = () => {
    dispatch(startSelectLocationTool(SelectLocationConfiguration.AddLocation));
  };

  const toggleAddLocation = () => {
    if (isSelectLocationToAddLocationActive) {
      dispatch(stopSelectLocationTool());
    }
    else {
      optionsModal({
        allowedPages: ALL_MAP_RELATED_PAGES,
        title: t('Add a Map Marker to your Map'),
        options: [
          {
            name: t('Input Address Information (Address, City, Latitude, etc)'),
            onChosen: () => addMultipleLocationsModal(),
          },
          {
            name: t('Place a Marker on the Map'),
            onChosen: onPlaceMarkerOnTheMap,
          },
        ],
        width: 600,
      });
    }
  };

  return (
    <RightSideMapToolsMenuItem
      icon={faMapMarkerPlus}
      active={isSelectLocationToAddLocationActive}
      onClick={toggleAddLocation}
      tooltip={t('Add Marker')}
      isLoading={isSelectLocationToAddLocationActive && isLoadingSelectLocation}
    />
  );
};
